import * as React from "react";

function BoxOpenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m17.24 125.5 41.7-83.38c3.03-6.06 9.56-9.56 16.29-8.72L320 63.1l-83.4 139c-7.4 13.3-22.3 19.1-36.2 15.2L37.07 170.6c-19.26-5.5-28.787-27.2-19.83-45.1zM320 63.1l244.8-29.7c6.7-.84 13.2 2.66 16.3 8.72l41.7 83.38c8.9 17.9-.6 39.6-19.9 45.1l-163.3 46.7c-13.9 3.9-28.8-1.9-36.2-15.2L320 63.1zm256 148.5v166.9c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.8 2.6-31 0l-204.1-51C78.99 419.7 64 400.5 64 378.5V211.6l48 13.7v153.2l184 46V184c0-13.3 10.7-24 24-24s24 10.7 24 24v240.5l184-46V225.3l48-13.7zM318.9 128h2.2z"
  }));
}

const ForwardRef = React.forwardRef(BoxOpenIcon);
export default ForwardRef;